module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tDocuments liés à l'opération\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, [_c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "tile-doc row"
  }, [_c('span', {
    staticClass: "icon-document-pdf"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tLettre de Mission\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((_vm.letterOfMission) ? _vm.letterOfMission.original_name + '.pdf' : 'Pas de fichier') + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "lmfile",
      "type": "file"
    },
    on: {
      "change": _vm.uploadLetterMissionFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-actions row"
  }, [(_vm.needForSign(_vm.letterOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.askForSignature(_vm.letterOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSoumettre une signature\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.canLoad(_vm.letterOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.procUpload('lmfile')
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v("\n\t\t\t\t\tCharger un fichier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.letterOfMission && !_vm.needForSign(_vm.letterOfMission)) ? _c('div', {
    staticClass: "status row"
  }, [_vm._v("\n\t\t\t\t\tAjouté le " + _vm._s(_vm.letterOfMission.universign_launch_date.split(' ')[0]) + "\n\t\t\t\t\t"), (_vm.letterOfMission.universign_status === 'completed') ? _c('span', {
    staticClass: "green inner-status"
  }, [_vm._v("Signé le " + _vm._s(_vm.letterOfMission.signature_date.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (_vm.letterOfMission.universign_status === 'ready') ? _c('span', {
    staticClass: "orange inner-status"
  }, [_vm._v("Signature en attente")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.letterOfMission) ? _c('div', {
    staticClass: "other-actions row"
  }, [(_vm.letterOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.callVerify(_vm.letterOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVérifier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.letterOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.relaunchTransaction(_vm.letterOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEnvoyer un mail de relance\n\t\t\t\t")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "tile-doc row"
  }, [_c('span', {
    staticClass: "icon-document-pdf"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tRapport de Mission\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((_vm.rapportOfMission) ? _vm.rapportOfMission.original_name + '.pdf' : 'Pas de fichier') + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "rmfile",
      "type": "file"
    },
    on: {
      "change": _vm.uploadCRFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-actions row"
  }, [(_vm.needForSign(_vm.rapportOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.askForSignature(_vm.rapportOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSoumettre une signature\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.canLoad(_vm.rapportOfMission)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.procUpload('rmfile')
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v("\n\t\t\t\t\tCharger un fichier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.rapportOfMission && !_vm.needForSign(_vm.rapportOfMission)) ? _c('div', {
    staticClass: "status row"
  }, [_vm._v("\n\t\t\t\t\tAjouté le " + _vm._s(_vm.rapportOfMission.universign_launch_date.split(' ')[0]) + "\n\t\t\t\t\t"), (_vm.rapportOfMission.universign_status === 'completed') ? _c('span', {
    staticClass: "green inner-status"
  }, [_vm._v("Signé le " + _vm._s(_vm.rapportOfMission.signature_date.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (_vm.rapportOfMission.universign_status === 'ready') ? _c('span', {
    staticClass: "orange inner-status"
  }, [_vm._v("Signature en attente")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.rapportOfMission) ? _c('div', {
    staticClass: "other-actions row"
  }, [(_vm.rapportOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.callVerify(_vm.rapportOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVérifier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.rapportOfMission.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.relaunchTransaction(_vm.rapportOfMission)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEnvoyer un mail de relance\n\t\t\t\t")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04eb7e8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MyTransactions/EditForm/Docs.vue
// module id = 1065
// module chunks = 0